import {useHistory, useIsLaunchTeaserPage} from '@aboutyou/router';
import {useRef} from 'react';
import {useRenderAsTwa} from '../Twa/hooks/useRenderAsTwa';

export const HIDE_HEADER_QUERY_PARAM = 'hideheader';
export const HIDE_FOOTER_QUERY_PARAM = 'hidefooter';

export const useFullScreenView = () => {
  const queryParams = new URLSearchParams(useHistory().location.search);
  const isOnLaunchTeaserPage = useIsLaunchTeaserPage();
  const isEnabled = useRenderAsTwa();

  const hideHeaderByQueryParam = useRef(
    queryParams.get(HIDE_HEADER_QUERY_PARAM) === '1',
  ).current;
  const hideFooterByQueryParam = useRef(
    queryParams.get(HIDE_FOOTER_QUERY_PARAM) === '1' || isEnabled,
  ).current;

  const isHeaderDisabled = hideHeaderByQueryParam || isOnLaunchTeaserPage;
  const isFooterDisabled = hideFooterByQueryParam || isOnLaunchTeaserPage;

  return {
    isHeaderDisabled,
    isFooterDisabled,
  };
};
